var _rect, _path;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTriangle = function SvgTriangle(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 30,
    viewBox: "0 0 90 30",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 24,
    fill: "#213348"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.129,1.29a2,2,0,0,1,2.741,0L47.328,20.544A2,2,0,0,1,45.957,24H5.043a2,2,0,0,1-1.371-3.456Z",
    transform: "translate(70 30) rotate(180)",
    fill: "#303e82"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTriangle, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDkwIDMwIj4KICA8cmVjdCB3aWR0aD0iOTAiIGhlaWdodD0iMjQiIGZpbGw9IiMyMTMzNDgiIC8+CiAgPHBhdGggZD0iTTI0LjEyOSwxLjI5YTIsMiwwLDAsMSwyLjc0MSwwTDQ3LjMyOCwyMC41NDRBMiwyLDAsMCwxLDQ1Ljk1NywyNEg1LjA0M2EyLDIsMCwwLDEtMS4zNzEtMy40NTZaIgogICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzAgMzApIHJvdGF0ZSgxODApIiBmaWxsPSIjMzAzZTgyIiAvPgo8L3N2Zz4=";
export { ForwardRef as ReactComponent };